import { useRouter } from '@/hooks/useRouter';

export const useAnchor = (
  url: string,
  urlTarget: string,
  disableNavigationScrollToTop?: boolean | null,
) => {
  const { push } = useRouter();

  const handleAnchorEvent = () => {
    if (url?.includes('#')) {
      const hash = url?.split('#')[1];
      const element = document.getElementById(hash);
      const elementTopToDocumentTop =
        element?.getBoundingClientRect()?.top ?? 0;
      if (element) {
        /** 240 is the value that needs to be shifted when the anchor jumps,
         * and the current header distance peaks at 180, so I've added an extra 60 for fault tolerance.
         * */

        window.scrollBy({
          top: elementTopToDocumentTop - 240,
          behavior: 'smooth',
        });
      }
    } else {
      if (urlTarget === '_blank') {
        window.open(url ?? '/', '_blank');
      } else {
        push(url ?? '/', undefined, { scroll: !disableNavigationScrollToTop });
      }
    }
  };

  return {
    handleAnchorEvent,
  };
};
